import { useEffect, useRef } from "react";

const NON_TEXT_INPUT_TYPES = new Set([
  "button",
  "submit",
  "reset",
  "checkbox",
  "radio",
  "file",
  "range",
  "color",
  "image",
]);

function isTextEntryElement(el) {
  if (!el) return false;
  if (el.isContentEditable || el.closest?.('[contenteditable="true"]'))
    return true;
  if (el.getAttribute?.("role") === "textbox") return true;
  if (el.tagName === "TEXTAREA") return true;
  if (el.tagName === "INPUT") {
    const type = (el.getAttribute("type") || "text").toLowerCase();
    return !NON_TEXT_INPUT_TYPES.has(type);
  }
  return false;
}

export default function useSpacebarShortcut(
  onTrigger,
  { enabled = true } = {},
) {
  const onTriggerRef = useRef(onTrigger);
  onTriggerRef.current = onTrigger;

  useEffect(() => {
    if (!enabled) return undefined;

    const handleKeyDown = (e) => {
      if (e.key !== " " && e.code !== "Space") return;
      if (e.repeat || e.metaKey || e.ctrlKey || e.altKey) return;

      if (isTextEntryElement(document.activeElement)) return;

      e.preventDefault();
      e.stopPropagation();
      onTriggerRef.current();
    };

    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [enabled]);
}
